import React from 'react';
import { useNavigate } from 'react-router-dom';

const SelectionHeader = () => {
    const navigate= useNavigate();

    const workerHandler =()=>{
       navigate("/worker")
    }
    const jobsHandler =()=>{
      navigate("/jobs")
    }
  return (
    <div className="w-full p-8 ">
      <div className=" mx-auto">
        {/* Ultra Premium Container */}
        <div className="relative bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 rounded-[2rem] overflow-hidden">
          {/* Premium Glass Border */}
          <div className="absolute inset-0 rounded-[2rem] p-[1px] bg-gradient-to-r from-blue-400/50 via-purple-400/60 to-indigo-400/50">
            <div className="h-full w-full rounded-[2rem] bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900"></div>
          </div>
          
          {/* Sophisticated Mesh Gradient */}
          <div className="absolute inset-0 opacity-40">
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-600/30 via-transparent to-purple-600/20"></div>
            <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-bl from-indigo-500/20 via-transparent to-blue-700/30"></div>
            <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-tr from-purple-600/25 via-transparent to-blue-500/15"></div>
          </div>
          
          {/* Elegant Floating Orbs */}
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-8 left-16 w-40 h-40 bg-gradient-to-r from-blue-400 to-cyan-300 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute top-12 right-20 w-32 h-32 bg-gradient-to-r from-purple-400 to-pink-300 rounded-full blur-2xl animate-pulse delay-1000"></div>
            <div className="absolute bottom-10 left-24 w-36 h-36 bg-gradient-to-r from-indigo-400 to-blue-300 rounded-full blur-3xl animate-pulse delay-500"></div>
          </div>
          
          {/* Premium Noise Texture */}
          <div className="absolute inset-0 opacity-[0.02] bg-gradient-to-br from-white to-transparent rounded-[2rem]"></div>
          
          {/* Main Content */}
          <div className="relative z-10 px-12 py-12 flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Sophisticated Title */}
            <div className="text-center lg:text-left max-w-2xl">
              <div className="mb-6">
                <h1 className="text-2xl lg:text-4xl font-black leading-[0.9] tracking-tight mb-4">
                  <span className="bg-gradient-to-r from-white via-blue-100 to-indigo-200 bg-clip-text text-transparent">
                    Need Help?
                  </span>
                  <br />
                  <span className="bg-gradient-to-r from-blue-300 via-purple-300 to-indigo-300 bg-clip-text text-transparent">
                    Book Trusted
                  </span>
                  <br />
                  <span className="bg-gradient-to-r from-cyan-300 via-blue-300 to-purple-300 bg-clip-text text-transparent">
                    Professionals
                  </span>
                </h1>
                
                <div className="flex items-center justify-center lg:justify-start gap-2 mt-4">
                  <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
                  <p className="text-lg font-semibold bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">
                    Instantly
                  </p>
                  <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse delay-500"></div>
                </div>
              </div>
              
              {/* Elegant Accent Line */}
              <div className="flex justify-center lg:justify-start">
                <div className="h-[2px] w-24 bg-gradient-to-r from-blue-400 via-purple-400 to-indigo-400 rounded-full shadow-lg"></div>
              </div>
            </div>
            
            {/* Ultra Premium Buttons */}
            <div className="flex flex-col gap-5">
              {/* Post Job Button */}
              <button className="group relative px-10 py-5 bg-white/95 backdrop-blur-sm text-slate-800 font-bold text-lg rounded-2xl shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 hover:scale-[1.02] transition-all duration-500 min-w-56 overflow-hidden border border-white/20" onClick={jobsHandler}>
                {/* Premium Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-50/80 via-purple-50/60 to-indigo-50/80 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
                
                {/* Animated Border */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-400/0 via-purple-400/20 to-blue-400/0 group-hover:from-blue-400/40 group-hover:via-purple-400/60 group-hover:to-blue-400/40 transition-all duration-500 p-[1px]">
                  <div className="h-full w-full rounded-2xl bg-white/95"></div>
                </div>
                
                <span className="relative z-10 flex items-center justify-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  Browse a Job
                </span>
                
                {/* Luxury Shimmer */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12 translate-x-full group-hover:-translate-x-full transition-transform duration-1200 ease-out"></div>
                </div>
              </button>
              
              {/* Browse Workers Button */}
              <button className="group relative px-10 py-5 bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 text-white font-bold text-lg rounded-2xl shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 hover:scale-[1.02] transition-all duration-500 min-w-56 overflow-hidden border border-blue-500/30" onClick={workerHandler}>
                {/* Premium Hover Gradient */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
                
                {/* Glowing Border Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-400/20 via-purple-400/40 to-indigo-400/20 group-hover:from-blue-400/60 group-hover:via-purple-400/80 group-hover:to-indigo-400/60 transition-all duration-500 blur-sm"></div>
                
                <span className="relative z-10 flex items-center justify-center gap-3 ">
                  <div className="w-6 h-6 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 group-hover:bg-white/30 transition-all duration-300">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                  Browse ZAP Heros
                </span>
                
                {/* Rainbow Shimmer */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 translate-x-full group-hover:-translate-x-full transition-transform duration-1200 ease-out"></div>
                </div>
              </button>
            </div>
          </div>
          
          {/* Sophisticated Ambient Elements */}
          <div className="absolute top-6 right-8 w-1 h-1 bg-blue-300 rounded-full animate-ping"></div>
          <div className="absolute bottom-8 left-8 w-1 h-1 bg-purple-300 rounded-full animate-ping delay-700"></div>
          <div className="absolute top-1/3 left-1/4 w-0.5 h-0.5 bg-indigo-300 rounded-full animate-pulse delay-1000"></div>
          
          {/* Premium Corner Accents */}
          <div className="absolute top-0 left-0 w-20 h-20 bg-gradient-to-br from-blue-400/10 to-transparent rounded-tl-[2rem]"></div>
          <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-br-[2rem]"></div>
        </div>
        
        {/* Ultra Premium Outer Glow */}
        <div className="absolute inset-0 rounded-[2rem] bg-gradient-to-r from-blue-600/10 via-purple-600/15 to-indigo-600/10 blur-3xl scale-110 -z-10"></div>
        <div className="absolute inset-0 rounded-[2rem] bg-gradient-to-br from-blue-500/5 to-purple-500/5 blur-2xl scale-105 -z-10"></div>
      </div>
    </div>
  );
};

export default SelectionHeader;